export default "__VITE_ASSET__B_ZTcx87__"